import {
  container,
  title,
  cardTitle,
  coloredShadow
} from "assets/jss/material-kit-pro-react.jsx";

const sectionSimilarStoriesStyle = {
  container,
  title,
  cardTitle,
  coloredShadow,
  textCenter: {
    textAlign: "center"
  },
  section: {
    backgroundPosition: "50%",
    backgroundSize: "cover",
    padding: "70px 0"
  },
  description: {
    color: "#999"
  }
};

export default sectionSimilarStoriesStyle;
